// Recovered compiled webpack factory 2332. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, {
    S8: () => i,
    cd: () =>
      function e(t, r = 3, n = 102400) {
        let a = i(t, r);
        return ~-encodeURI(JSON.stringify(a)).split(/%..|./).length > n ? e(t, r - 1, n) : a;
      },
  });
  var n = r(16649),
    a = r(73314),
    o = r(85236);
  function i(e, t = 100, r = Infinity) {
    try {
      return (function e(
        t,
        r,
        i = Infinity,
        s = Infinity,
        l = (function () {
          let e = new WeakSet();
          return [
            function (t) {
              return !!e.has(t) || (e.add(t), !1);
            },
            function (t) {
              e.delete(t);
            },
          ];
        })(),
      ) {
        let [u, c] = l;
        if (
          null == r ||
          ["boolean", "string"].includes(typeof r) ||
          ("number" == typeof r && Number.isFinite(r))
        )
          return r;
        let f = (function (e, t) {
          try {
            if ("domain" === e && t && "object" == typeof t && t._events) return "[Domain]";
            if ("domainEmitter" === e) return "[DomainEmitter]";
            if ("undefined" != typeof global && t === global) return "[Global]";
            if ("undefined" != typeof window && t === window) return "[Window]";
            if ("undefined" != typeof document && t === document) return "[Document]";
            if ((0, n.L2)(t)) return (0, o.nY)(t);
            if ((0, n.mE)(t)) return "[SyntheticEvent]";
            if ("number" == typeof t && !Number.isFinite(t)) return `[${t}]`;
            if ("function" == typeof t) return `[Function: ${(0, o.qQ)(t)}]`;
            if ("symbol" == typeof t) return `[${String(t)}]`;
            if ("bigint" == typeof t) return `[BigInt: ${String(t)}]`;
            let r = (function (e) {
              let t = Object.getPrototypeOf(e);
              return t?.constructor ? t.constructor.name : "null prototype";
            })(t);
            if (/^HTML(\w*)Element$/.test(r)) return `[HTMLElement: ${r}]`;
            return `[object ${r}]`;
          } catch (e) {
            return `**non-serializable** (${e})`;
          }
        })(t, r);
        if (!f.startsWith("[object ")) return f;
        if (r.__sentry_skip_normalization__) return r;
        let d =
          "number" == typeof r.__sentry_override_normalization_depth__
            ? r.__sentry_override_normalization_depth__
            : i;
        if (0 === d) return f.replace("object ", "");
        if (u(r)) return "[Circular ~]";
        if (r && "function" == typeof r.toJSON)
          try {
            let t = r.toJSON();
            return e("", t, d - 1, s, l);
          } catch {}
        let p = Array.isArray(r) ? [] : {},
          h = 0,
          _ = (0, a.W4)(r);
        for (let t in _) {
          if (!Object.prototype.hasOwnProperty.call(_, t)) continue;
          if (h >= s) {
            p[t] = "[MaxProperties ~]";
            break;
          }
          let r = _[t];
          ((p[t] = e(t, r, d - 1, s, l)), h++);
        }
        return (c(r), p);
      })("", e, t, r);
    } catch (e) {
      return { ERROR: `**non-serializable** (${e})` };
    }
  }
}
